import React, { useEffect, useReducer } from 'react';
import { useHistory } from "react-router-dom";

import RewardContext from '../../context/reward-context';
import rewardReducer from '../../reducers/reward-reducer';
import { getVouchersForRedeem, getTransactionLogsByStudentNumber, getCampaigns } from '../../actions/reward-actions';
import { getStudentCoins } from '../../actions/share-actions';
import RewardShop from './RewardShop';
import RewardRedemptionLog from './RewardRedemptionLog';
import Loading from '../shared/Loading';
import { DefaultLayout, TabsCategory } from '../shared/component';

import { getIconReward } from '../../utils/helpers/icon/iconHelper';

const Reward = () => {
    const [rewardContext, dispatch] = useReducer(rewardReducer);
    const [isLoading, setIsLoading] = React.useState(true);
    const history = useHistory();

    useEffect(() => {
        initRewardItems();
        initCampaigns();
        initStudentCoins();
        initTransactionLogsByStudentNumber();
    }, []);

    const initRewardItems = async () => {
        const response = await getVouchersForRedeem();
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        let rewardItems = response.data;
        rewardItems = rewardItems.map((reward) => ({ ...reward, quantity: 0 }));
        dispatch({ type: 'SET_REWARD_ITEMS', rewardItems });

    };

    const initStudentCoins = async () => {
        const response = await getStudentCoins();
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        dispatch({ type: 'SET_STUDENT_COINS', studentCoins: response.data });
    };

    const initCampaigns = async () => {
        const response = await getCampaigns();
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        dispatch({ type: 'SET_CAMPAIGNS', campaigns: response.data });
    };

    const initTransactionLogsByStudentNumber = async () => {
        const response = await getTransactionLogsByStudentNumber()
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        const rewardRedemptionLog = response.data
        dispatch({ type: 'SET_REWARD_REDEMPTION_LOG', rewardRedemptionLog });
        setIsLoading(false);
    }

    if (isLoading) return <Loading />;

    const dataTabsCategory = [
        {
            type: "Reward",
            label: 'Shop',
            component: <RewardShop />,
            description: 'Shop Options',
        },
        {
            type: "Reward",
            label: 'Transaction History',
            component: <RewardRedemptionLog />,
            description: 'Transaction History',
        }
    ]

    return (
        <RewardContext.Provider value={{ rewardContext, dispatch }}>
            <DefaultLayout
                title="Shop"
                type = 'Reward'
                image={getIconReward().img_reward_bg_header}
            >
                <TabsCategory
                    dataTabsCategory={dataTabsCategory}
                />
            </DefaultLayout>
        </RewardContext.Provider>
    );
}

export default Reward;